import Header from "../../components/header";
import LeftMenu from "../../components/left-menu";
import Grid from '@mui/material/Grid';
import "./style.css";
import 'bootstrap/dist/css/bootstrap.min.css';



export default function Template(){
    return <div className="col-12 d-flex p-5 mt-5">
        <div className="col-6">
            <p>PT. SUPARDI NETHANEL HUSAIN</p>
            <p>Jl. Puri Permai 2 Blok W3 No.9</p>
            <p>PT. SUPARDI NETHANEL HUSAIN</p>
            <p className="mb-5">PT. SUPARDI NETHANEL HUSAIN</p>
            <p><b>Phone:</b> 021-28541720</p>
        </div>
        <div className="col-6">
            <p>Picture Logo</p>
            <p><b>Proforma Invoice</b></p>
        </div>
    </div>
    };